export default __webpack_public_path__ + "static/work-13359836977b681bafa6feee81eef9e0.webp";